import { observable, action, reaction } from 'mobx'
import { UserStore, ApiStore } from '~/stores'
import { TRequest } from '~/types'
import { observer } from 'mobx-react-lite'

export class NewRequestStore {
  @observable
  public loading = false

  @observable
  public request: Partial<TRequest> = {}

  constructor(private userStore: UserStore, private apiStore: ApiStore) {
    try {
      this.request = JSON.parse(localStorage.getItem('@ps/new-request') || '{}')
    } catch (error) {
      localStorage.removeItem('new-request')
    }

    this.request = {
      ...this.request,
      ...userStore.userProfile.contacts,
      Holder: userStore.userID,
    }

    const dispose = reaction(
      () => userStore.userProfile,
      () => {
        dispose()
        this.request = {
          ...this.request,
          ...userStore.userProfile.contacts,
        }
      },
    )
  }

  @action
  public setRequest = (request: Partial<TRequest>) => {
    this.request = {
      ...this.request,
      ...request,
    }
  }

  @action
  public createRequest = () => {
    this.loading = true

    localStorage.setItem(
      '@ps/new-request',
      JSON.stringify({
        ...this.request,
        Name: undefined,
        Group: undefined,
        Origin: undefined,
        Condition: undefined,
        Comment: undefined,
      } as TRequest),
    )

    return Promise.all([
      this.apiStore
        .createRequest({ ...this.request })
        .then(console.log)
        .catch(console.error)
        .finally(() => {
          this.loading = false
        }),

      this.userStore.setUserProfile({
        ...this.userStore.userProfile,
        contacts: {
          ...{
            Address1: this.request.Address1,
            Address2: this.request.Address2,
            City: this.request.City,
            State: this.request.State,
            PostCode: this.request.PostCode,
            Email: this.request.Email,
            Phone: this.request.Phone,
          },
          ...this.userStore.userProfile.contacts,
        },
      }),
    ])
  }
}
